// 判断是否为自定义浏览框
export const isCustomBrowser = (module: string, type?: string) => module === 'bcw' && type?.indexOf('customBrowser_') === 0;

export const getCustomBrowserConfigStore = () => import(
  /* webpackChunkName: "searchadvanced" */
  './CustomBrowserConfigStore'
)